import { RescheduleFilters, RescheduleItemType, AbsenceCategory } from "@myapp/contract";

export interface RescheduleFiltersForm {
  type: RescheduleItemType | "";
  title: string;
  technicianName: string;
  reason: AbsenceCategory | "";
  dateFrom: string;
  dateTo: string;
  sortField: "scheduledDate" | "type" | "technicianName";
  sortDirection: "ASC" | "DESC";
}

export const INITIAL_RESCHEDULE_FILTERS: RescheduleFiltersForm = {
  type: "",
  title: "",
  technicianName: "",
  reason: "" as AbsenceCategory | "",
  dateFrom: "",
  dateTo: "",
  sortField: "scheduledDate",
  sortDirection: "DESC",
};

export const mapFiltersFormToApi = (
  filters: RescheduleFiltersForm,
  limit: number,
): RescheduleFilters => ({
  limit,
  type: filters.type || undefined,
  title: filters.title || undefined,
  technicianName: filters.technicianName || undefined,
  reason: filters.reason || undefined,
  dateFrom: filters.dateFrom || undefined,
  dateTo: filters.dateTo || undefined,
  sortField: filters.sortField,
  sortDirection: filters.sortDirection,
});
